import { getObjectValue } from './getObjectValue';

type WithOrderAndId = { order?: number; id?: number };

const sortByOrderAndId = <T extends WithOrderAndId>(arrayToSort: T[]) =>
  arrayToSort.toSorted((a, b) => {
    const orderA = getObjectValue(a)?.order ?? 0;
    const orderB = getObjectValue(b)?.order ?? 0;
    if (orderA !== orderB) {
      return orderA - orderB;
    }
    return (a.id ?? 0) - (b.id ?? 0);
  });

export default sortByOrderAndId;
